import { render, staticRenderFns } from "./home-button.vue?vue&type=template&id=70ce593b&scoped=true&"
import script from "./home-button.vue?vue&type=script&lang=js&"
export * from "./home-button.vue?vue&type=script&lang=js&"
import style0 from "./home-button.vue?vue&type=style&index=0&id=70ce593b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce593b",
  null
  
)

export default component.exports